var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"texto-menu-activo"},[_c('tr',{style:({ 'height': _vm.height })},[(_vm.title)?_c('td',{attrs:{"valign":"middle"}},[_c('center',[_vm._v(_vm._s(_vm.title))])],1):_c('td',{attrs:{"valign":"middle"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }